import { render, staticRenderFns } from "./dna.vue?vue&type=template&id=26d534d8"
import script from "./dna.vue?vue&type=script&setup=true&lang=js"
export * from "./dna.vue?vue&type=script&setup=true&lang=js"
import style0 from "./dna.vue?vue&type=style&index=0&id=26d534d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports